var map = {
	"./Instituto_Tecnologico_de_Oaxaca.png": 9446,
	"./address_image.svg": 3906,
	"./animated_logo.svg": 9083,
	"./cloud_infrastructure.svg": 883,
	"./contactMail.png": 3189,
	"./data_science.svg": 8699,
	"./developerActivity.svg": 9257,
	"./education.svg": 1118,
	"./experience.svg": 7480,
	"./feelingProud.svg": 8294,
	"./fullstack.svg": 5137,
	"./github_logo.png": 8017,
	"./googleAssistant.svg": 7291,
	"./google_logo.png": 9389,
	"./iidtec.png": 3124,
	"./jsFramework.svg": 9655,
	"./manOnTable.svg": 7473,
	"./me.png": 5448,
	"./programmer.svg": 4700,
	"./projects_image.svg": 1240,
	"./talksCardBack.svg": 6654,
	"./talksCardBackAlt.svg": 3291,
	"./ui_ux_design.svg": 9163,
	"./visous.png": 3871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;